module.exports = __webpack_public_path__ + "static/img/img01.0b7029c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img01.png
// module id = YEAZ
// module chunks = 2